/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2023-03-31 16:45:24
 * @LastEditTime: 2024-06-27 16:52:28
 */
/* eslint-disable */
/* tslint:disable */

import banner from '../../images/banner.png';

const HomeBanner = () => {
  const enter = () => {
    if ((window as any)['enter'] === 'college') {
      location.href = '/enter/college';
    } else {
      location.href = '/enter/enterprise';
    }
  };
  return (
    <div className='home-div-bannerContainer'>
      <img src={banner} />
      {/*<Carousel autoplay>
        <div>
          <img src={banner} />
        </div>
        <div>
          <img src={banner} />
        </div>
      </Carousel>*/}
      {/* <button type="button" className="blueButton" onClick={enter}  style={{position: "absolute", left: "50%", bottom: "15%", transform: "translateX(-50%)"}} >
            我要报名
        </button> */}
    </div>
  );
};

export default HomeBanner;
